
export interface GetReportRequest {
    tenant_id: number;
    report_key: string;
    rpt_fltr_relative_date_range: RelativeDate|string;
    rpt_fltr_payload: string;
    analytics_path_param?: string;
}

export enum RelativeDate
{
    Yesterday = -1,
    LastMonth = -3,
    LastSevenDays = -7,
    LastThirtyDays = -30,
    Today = 0,
    Tomorrow = 1,
    ThisMonth = 3,
    ThisQuarter = 33,
    CustomDateRange = 99
}

export enum FilterTimePeriod
{
    Today = "0",
    Tomorrow = "1",
    ThisMonth = "3",
    ThisQuarter = "33",
    CustomDateRange = "99"
}

export interface ReportDataForCampaign {
    report_key: string;
    rpt_fltr_relative_date_range: RelativeDate;
    rpt_fltr_payload: string;
}




